import {sendWebsocketMessage} from '../../../../../../App'
import { getMarketDataRoute } from '../../../marketDataRouting';
/**
 * A feature of quick trade is that we guess whether the user wants to go long or short based on the direction 
 * of the current 1 min candle. This message requests that information
 * @param {*} symbol request symbol
 * @param {*} dataSource request datasource
 * @param {*} id id of message. this key will be sent back in order to identify the data you requested (as opposed to other requests for this kind of information)
 */
export function requestQuickTradeDirection(symbol, dataSource, brokerage, id)
{
    const route = getMarketDataRoute({
        dataSource,
        brokerage,
        messageType: "quickTradeDirection",
        symbol,
    });
    if (!route.valid) {
        return;
    }
    const msg = {
        messageType: "quickTradeDirection",
        symbol: symbol,
        dataSource: dataSource,
        brokerage: route.brokerage,
        id: id
    }
    sendWebsocketMessage(msg);
}
